import { createEffect } from 'effector'
import { $transferPolicy, $transferPolicyLoading } from './store'
import { TransferPolicyAPI } from '../../services/api/TransferPolicy'
import { TransferPolicyMode } from '../../shared/enum'

export const getTransferPolicyFx = createEffect(async (): Promise<any> => {
  const response = await TransferPolicyAPI.getTransferPolicy()
  return response.data.data
})

export const updateTransferPolicyFx = createEffect(async (data: {
  mode: TransferPolicyMode
  countries: string[]
}): Promise<any> => {
  await Promise.all([
    TransferPolicyAPI.postTransferPolicyMode({ mode: data.mode }),
    TransferPolicyAPI.postTransferPolicyCountries({ countries: data.countries }),
  ])

  const response = await TransferPolicyAPI.getTransferPolicy()
  return response.data.data
})

$transferPolicy.on(getTransferPolicyFx.doneData, (_, data) => data)
$transferPolicy.on(updateTransferPolicyFx.doneData, (_, data) => data)

$transferPolicyLoading
  .on(getTransferPolicyFx, () => true)
  .on(getTransferPolicyFx.finally, () => false)
  .on(updateTransferPolicyFx, () => true)
  .on(updateTransferPolicyFx.finally, () => false)
